<template>
  <el-row>
    <el-col>
      <el-tabs
        v-loading="isLoading"
        type="border-card"
      >
        <el-tab-pane label="Sales Pipes">
          <PipesTable
            :pipes="pendingLeads"
            table-name="STARTING"
            class="mb-3"
          />

          <PipesTable
            :pipes="awaitingDecisionLeads"
            table-name="AWAITING DECISION"
            class="mb-3"
          />

          <PipesTable
            :pipes="workingOnLeads"
            table-name="WORKING ON"
          />
        </el-tab-pane>

        <el-tab-pane label="Trading">
          <PipesTable
            :pipes="tradingLeads"
            table-name="TRADING"
          />
        </el-tab-pane>

        <el-tab-pane label="Unsuccessful">
          <PipesTable
            :pipes="lostLeads"
            table-name="UNSUCCESSFUL"
          />
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import PipesTable from '@/components/Application/Sales/Pipes/Table'
import Filter, { IS } from '@/plugins/sdk/Filter'

export default {
  components: {
    PipesTable
  },
  data () {
    return {
      breadcrumb: {
        name: 'Pipes',
        route: { name: 'sales-pipes' }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoading: true,
      filters: [
        new Filter('status', IS, [
          'lead',
          'working on',
          'awaiting decision',
          'pending',
          'trading',
          'lost'
        ])
      ],
      leads: []
    }
  },
  computed: {
    leadLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'lead' })
    },
    workingOnLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'working on' })
    },
    awaitingDecisionLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'awaiting decision' })
    },
    pendingLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'pending' })
    },
    tradingLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'trading' })
    },
    lostLeads () {
      return this
        .$_
        .filter(this.leads, { status: 'lost' })
    }
  },
  created () {
    this
      .$sdk
      .account_lead
      .list(request => {
        request.include = [
          'account.portfolio.branch',
          'account.events',
          'incumbent_carriers.carrier',
          'suggested_carriers.carrier'
        ]

        request.filters = this.filters
      })
      .then(res => { this.leads = res })
      .finally(() => { this.isLoading = false })
  },
  methods: {
    async reload () {
      this.isLoading = true

      await this.leads.reload(request => { request.filters = this.filters })

      this.isLoading = false
    }
  }
}
</script>
